module.exports = __webpack_public_path__ + "img/GAME_CATCHTHEFISH1.ec259b72.jpg";